import React from 'react';
import FormGroup from './FormGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
/** Props for FormSelect - most are optional */
export interface FormSelectProps {
  name?: string;
  label?: string;
  children?: React.ReactNode;
  defaultValue?: any;
  placeholder?: string;
  register?: any;
  error?: any;
  errorMessage?: string;
  required?: boolean;
  className?: string;
  joinedButton?: boolean;
  joinedButtonIcon?: any;
  joinedButtonClick?: () => void;
  joinedButtonDisabled?: boolean;
  onChange?: any;
  autoFocus?: boolean;
  disabled?: boolean;
  testId?: string;
}

const FormSelect = (
  {
    label,
    name,
    children,
    defaultValue,
    placeholder,
    register,
    error,
    errorMessage,
    required,
    className = '',
    joinedButton,
    joinedButtonIcon,
    joinedButtonClick,
    joinedButtonDisabled,
    onChange,
    autoFocus = false,
    disabled = false,
    testId,
  }: FormSelectProps,
  ...rest: Record<string, unknown>[]
) => {
  // Common properties
  let selectProps: Record<string, unknown> = {
    'aria-label': label,
    name,
    placeholder,
    defaultValue: defaultValue,
    onChange: onChange,
    autoFocus: autoFocus,
    disabled: disabled,
  };

  // If using react-hook-form, add register and required properties
  if (register && name) {
    selectProps = {
      ...selectProps,
      ...register(name, { required, onChange }),
    };
  }

  return (
    <FormGroup
      label={label}
      error={error}
      errorMessage={errorMessage}
      required={required}
      {...rest}
    >
      {joinedButton ? (
        <div className="input-group">
          <select
            {...selectProps}
            className={`form-control float-left ${className || ''}`}
            style={{ width: 'calc(100% - 45px)' }}
            data-cy={testId}
          >
            {children}
          </select>
          <button
            type="submit"
            onClick={joinedButtonClick}
            className="btn btn-primary float-left r-corners-right"
            disabled={joinedButtonDisabled}
          >
            <FontAwesomeIcon icon={joinedButtonIcon} aria-hidden="true" />
          </button>
        </div>
      ) : (
        <select
          {...selectProps}
          className={`form-control ${className || ''}`}
          data-cy={testId}
        >
          {children}
        </select>
      )}
    </FormGroup>
  );
};

export default FormSelect;
